import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "contexts/AuthContext";
import { isQuantitySurveyorRouteAllowed } from "./utils";
import { OrganizationType } from "common/constants";

/**
 * OrganizationGuard
 *
 * Handles org-type based route authorization.
 * Currently enforces allowlist for `quantity_surveyor`.
 *
 * Future-ready for RBAC extension.
 */
export const OrganizationGuard = () => {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();

  const pathname = location.pathname;

  if (loading) {
    return <div>Loading...</div>;
  }

  // Not authenticated → let auth logic handle (or redirect here)
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const organizationType = user?.organizationType;

  // If not quantity_surveyor → no restriction
  if (organizationType !== OrganizationType.QUANTITY_SURVEYOR) {
    return <Outlet />;
  }

  // Allowlist for quantity_surveyor
  const isAllowed = isQuantitySurveyorRouteAllowed(pathname);

  if (!isAllowed) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};
